<template>
    <section >
       <nav class="navbar navbar-expand-lg navbar-dark bg-dark evangelio-lectura ">
            <a class="navbar-brand p-3" href="/"><img src="/images/logo.svg"><p class="logo-titulo">Parroquia del Espíritu Santo</p></a>
        <button  v-if="isAuthenticated" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>


            <div v-if="isAuthenticated" class="collapse navbar-collapse"  id="navbarNavDropdown">
            <ul class="navbar-nav"  style="margin-left: auto;">
            
                <li class="nav-item dropdown active">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Misal
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                    <router-link class="dropdown-item" to="/misas">Todas las misas</router-link>
                    <router-link class="dropdown-item" to="/misas/agrega">Agregar misa</router-link>
                </ul>
                </li>
                <li class="nav-item">
                <a class="nav-link" href="#" @click="logout()">Cerrar Sesión</a>
                </li>
            </ul>
            </div>
        </nav>
        <div class="container p-5 pt-2" >
            <div class="row">
                <div class="col-6"><h1>Reporte QR</h1></div>
                <div class="col-6 d-flex justify-content-end pb-2"><button class="btn btn-sm btn-success" v-print="printObj">Imprimir página</button></div>
            </div>
            <div id="loading" v-show="printLoading"></div>
            <div class="card m-auto" style="width:500px;height:687.5px">
                <div class="card-body text-center"  id="printMe">
                    <div style="margin-top: 20%;">
                    <h5 class="card-title text-center pb-5">Lee el evangelio desde cualquier dispositivo.<br> Escanea el código QR y sigue misa con nosotros.</h5>
                     <QRCodeVue3
                        :width="400"
                        :height="400"
                        :value="URLEvangelio"
                        :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'H' }"
                        :image="logo"
                        :imageOptions="{ hideBackgroundDots: true, imageSize: 0.4, margin: 0 }"
                        :dotsOptions="{
                            type: 'dots',
                            color: '#000000',
                            gradient: {
                            type: 'linear',
                            rotation: 0,
                            colorStops: [
                                { offset: 0, color: '#000000' },
                                { offset: 1, color: '#000000' },
                            ],
                            },
                        }"
                        :backgroundOptions="{ color: '#ffffff' }"
                        :cornersSquareOptions="{ type: 'dot', color: '#000000' }"
                        :cornersDotOptions="{ type: undefined, color: '#000000' }"
                        fileExt="png"
                        myclass="my-qur"
                        imgclass="img-qr"
                        downloadButton="my-download"
                        :downloadOptions="{ name: 'vqr', extension: 'png' }"
                        />
                </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import moment from 'moment';
import QRCodeVue3 from "qrcode-vue3";
import print from 'vue3-print-nb'

require('moment/locale/es')
export default {
    directives: { print},
    components: { QRCodeVue3 },
     data(){
        return{
            date: '',
            logo: '/images/logo.png',
            printLoading: true,
            printObj: {
              id: "printMe",
              url:false,
              popTitle: 'QR',
              extraCss: "https://cdn.bootcdn.net/ajax/libs/animate.css/4.1.1/animate.compat.css, https://cdn.bootcdn.net/ajax/libs/hover.css/2.3.1/css/hover-min.css",
              extraHead: '<meta http-equiv="Content-Language"content="es-mx"/>',
              beforeOpenCallback (vue) {
                vue.printLoading = true
              },
              openCallback (vue) {
                vue.printLoading = false
              }
            }
        }
  },
  
  methods:{
    format(date,format){
      return moment(date).format(format);
    },
     logout(){
      this.$auth0.logout({ returnTo: window.location.origin });
    },
    
  },
  computed:{
    isAuthenticated(){
            return this.$auth0.isAuthenticated.value
        },
    URLEvangelio(){
      return process.env.VUE_APP_BASE_URL + 'misa'
    },
  }
}
</script>